/**
 * Homepage Logo Scroll
 */
$('body').addClass(navigator.platform);
var lastScrollTop = 0;
const initialVal = [-115, -90],
    finalVal = [0, 25];
if (window.ShopifyAnalytics.meta.page.pageType === 'home') {
    const mainLogoInterval = setInterval(() => {
        const mainLogo = document.getElementById('main-logo');

        console.log('Waiting for logo')

        if (mainLogo) {
            logoScroll();
            clearInterval(mainLogoInterval)
            console.log('logo loaded')
        }
    }, 100)

    window.addEventListener('resize', logoScroll)

    $(window).scroll(function () {
        if (window.innerWidth < 751) {
            if ($('.mobile.paralax-title').isInViewport()) {
                // const title = $('.about-us-banner-copy .paralax-title'),
                //     secTitle = $('.mobile.paralax-title');

                // let titleTop = Number(title.css('top').split('px')[0]),
                //     secTitleTop = Number(secTitle.css('top').split('px')[0]);

                // var st = window.scrollY || document.documentElement.scrollTop;
                // if (st > lastScrollTop) {
                //     if (titleTop < finalVal[0]) {
                //         title.css('top', titleTop + 1 + 'px')
                //         secTitle.css('top', secTitleTop + 1 + 'px')
                //     }
                // } else if (st < lastScrollTop) {
                //     // upscroll code
                //     if (titleTop > initialVal[0]) {
                //         title.css('top', titleTop - 1 + 'px')
                //         secTitle.css('top', secTitleTop - 1 + 'px')
                //     }
                // }
                // lastScrollTop = st <= 0 ? 0 : st;
            }
        }
    });

}
function logoScroll() {
    const logo = document.getElementsByClassName('main-logo')[0],
        logoImg = document.getElementById('main-logo'),
        header = document.getElementsByClassName('section-header')[0];

    const startLogoSize = mobV() ? (vwToPix(100) - 30) : vwToPix(94),
        finLogoSize = mobV() ? (window.innerWidth > 374 ? 125 : 80) : 210,
        startLeftPos = mobV() ? 15 : vwToPix(2),
        finLeftPos = mobV() ? 15 : vwToPix(2),
        step = 4,
        sizeStep = (startLogoSize - finLogoSize) / step,
        posStep = (-startLeftPos + finLeftPos) / step;

    setImgParams(startLogoSize, startLeftPos);

    // Set sizes
    const sizeStepArr = [];
    for (let i = startLogoSize; i > finLogoSize; i -= sizeStep) {
        sizeStepArr.push(i)
    }
    sizeStepArr.push(finLogoSize);

    // set position
    const posStepArr = [];
    for (let i = startLeftPos; i < finLeftPos; i += posStep) {
        posStepArr.push(i)
    }
    posStepArr.push(finLeftPos);

    // handel function
    function setLogoParams() {
        var logoRect = logo.getBoundingClientRect();

        let mp = Math.round(-(logoRect.top / 100));

        if (mp <= step) {
            logoImg.setAttribute('opacity', mp); // set attrs for css
            document.getElementsByClassName('header-wrapper')[0].setAttribute('step', mp);
            setImgParams(sizeStepArr[mp], posStepArr[mp]);
        } else {
            logoImg.setAttribute('opacity', step); // set attrs for css
            document.getElementsByClassName('header-wrapper')[0].setAttribute('step', step);
            setImgParams(sizeStepArr[step], posStepArr[step]);
        }
    }
    function setImgParams(width, left) {
        logoImg.style.width = width + 'px';
        logoImg.style.left = left + 'px';
    }

    // Init 
    window.removeEventListener('scroll', setLogoParams);
    window.addEventListener('scroll', setLogoParams);

    setLogoParams();
}

function position(el) {
    for (var pos = [0, 0]; el; el = el.offsetParent) {
        pos[0] += el.offsetLeft - el.scrollLeft;
        pos[1] += el.offsetTop - el.scrollTop;
    }
    return pos;
}

function vwToPix(param) {
    return (window.innerWidth * param) / 100
}

function mobV() {
    return window.innerWidth < 550;
}



if (window.innerWidth < 750) {
    const $title = $('.footer-block').find('.footer-block__heading'),
        $content = $('.footer-block').find('ul');

    $content.hide();

    $title.on('click', function () {
        let $curContent = $(this).parent().find('ul');

        $(this).toggleClass('active');

        $curContent.slideToggle();
    })
}


/**
 * Product Page
 */
// sub type state

//window.subscribtionType = 'prod_sub';
window.subscribtionType = 'one_time';

function initRelatedSlider() {
    if (window.innerWidth < 751) {
        $('slider-component .product-grid').slick({
            dots: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            prevArrow:
                '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.54 26.24"><g><path class="cls-1" d="m12.12.42L.42,12.12c-.56.56-.56,1.46,0,2.01l11.7,11.7c.56.56,1.46.56,2.01,0,.28-.28.42-.64.42-1.01s-.14-.73-.42-1.01L3.43,13.12,14.13,2.43c.28-.28.42-.64.42-1.01s-.14-.73-.42-1.01c-.56-.56-1.46-.56-2.01,0Z"/></g></svg>Previous</button>',
            nextArrow:
                '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.54 26.24"><g><path class="cls-1" d="m2.43,25.83l11.7-11.7c.56-.56.56-1.46,0-2.01L2.43.42C1.87-.14.97-.14.42.42c-.28.28-.42.64-.42,1.01s.14.73.42,1.01l10.69,10.69L.42,23.82c-.28.28-.42.64-.42,1.01s.14.73.42,1.01c.56.56,1.46.56,2.01,0Z"/></g></svg>Next</button>',
        });
    }
}

if (window.ShopifyAnalytics.meta.page.pageType === 'collection') {
    // onElementReady('.collection slider-component', () => {
    //     // $('.related-products').appendTo('.related-container');

    //     initRelatedSlider();
    // })

    $('.collection slider-component').on('change', '.select__select', function (e) {
        const parent = $(this).parents('.product-form__input--dropdown');
        const input = parent.next().find('input[name="id"]');

        input.val(e.currentTarget.value);
    })
}

if (window.ShopifyAnalytics.meta.page.pageType === 'product') {
    setTimeout(() => { // options fix
        $('.value_bottles').click()
    }, 300)
    onElementReady('.appstle_subscription_wrapper', function () {
        // Create select of radio values
        $('.appstleRadioSellingPlanWrapper').find('.appstle-radio-wrapper').each((i, e) => {
            const input = $(e).find('input[type="radio"]'),
                value = $(e).find('input[type="radio"]').val(),
                label = $(e).find('label > span').text().split(' ');

            const option = $('<option></option>');
            option.val(value);
            option.text(`${label[0]} ${label[1]} ${label[2]} ${label[3]}`);

            if (input.attr('checked') === 'checked') {
                option.attr('selected', true)
            }

            $('#prod_sub_select').append(option);
        });

        // Select Subscription by default
        $('.appstle_subscription_radio_wrapper').find('> .appstle_radio_label').click();

        //setPrice
        setAmount();
    })
    // onElementReady('.collection slider-component', () => {
    //     $('.related-products').appendTo('.related-container');

    //     initRelatedSlider();
    // })

    $('variant-radios input[type="radio"]').on('change', () => {
        setTimeout(() => {
            if (window.subscribtionType == 'prod_sub') {
                $('#prod_sub_input').click()
                $('#prod_sub_select').find('option')[0].selected = true;
                $('#prod_sub_select').change();
            } else {
                $('#one_time_input').click()
            }

            setAmount()
        }, 300)

    })


    $('select, input[type="radio"]').on('change', function () {
        var currentPos = $(window).scrollTop();
        $('html, body').scrollTop(currentPos);
    });

    $('.sub-tabs input[type="radio"]').on('click', function (e) {
        // $('.sub-tabs-content .tab-content').addClass('visually-hidden')
        // $('#' + e.currentTarget.value).removeClass('visually-hidden');

        window.subscribtionType = e.currentTarget.value;

        const triggerTarget = e.currentTarget.getAttribute('dataTriggerTarget');
        $(triggerTarget).find('> .appstle_radio_label').click();

        setAmount();
    })

    $('#prod_sub_select').on('change', function (e) {
        $('input#' + e.currentTarget.value).click()

        setAmount();
    })

    $('.collection slider-component').on('change', '.select__select', function (e) {
        const parent = $(this).parents('.product-form__input--dropdown');
        const input = parent.next().find('input[name="id"]');

        input.val(e.currentTarget.value);
    })


    function setAmount() {
        const $oneTimeContainer = $('.appstle_one_time_price_wrapper'),
            $subsContainer = $('.appstle_subscription_amount_wrapper');


        const $priceContainer = $('product-info .price__regular .price-item--regular'),
            $loader = $('.product-price .loading-overlay');

        let price;

        if (window.subscribtionType == 'prod_sub') {
            price = $subsContainer.find('.appstle_subscription_amount').html();
        }
        if (window.subscribtionType == 'one_time') {
            price = $oneTimeContainer.find('.appstle_subscription_amount').html();
        }

        $loader.removeClass('hidden')
        setTimeout(() => {
            $priceContainer.html(price)

            $loader.addClass('hidden');
        }, 1500)
    }
}

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).scroll(function () {

    // Add parallax scrolling to all images in .paralax-image container
    $('.parallax-image').each(function () {
        // only put top value if the window scroll has gone beyond the top of the image
        if ($(this).offset().top < $(window).scrollTop()) {
            // Get ammount of pixels the image is above the top of the window
            var difference = $(window).scrollTop() - $(this).offset().top;
            // Top value of image is set to half the amount scrolled
            // (this gives the illusion of the image scrolling slower than the rest of the page)
            var half = (difference / 2) + 'px',
                transform = 'translate3d( 0, ' + half + ',0)';

            $(this).find('img').css('transform', transform);
        } else {
            // set to image negative top offset
            var difference = $(this).offset().top - $(window).scrollTop();
            var half = (difference / 2) + 'px',
                transform = 'translate3d( 0, -' + half + ',0)';

            $(this).find('img').css('transform', transform);

            // if image is below the top of the window set top to 0
            // $(this).find('img').css('transform', 'translate3d(0,0,0)');
        }
    });


    $('.forced-animation').each(function () {
        if ($(this).offset().top < ($(window).scrollTop() + $(window).innerHeight())) {
            this.classList.remove('scroll-trigger--offscreen');
        } else {
            this.classList.add('scroll-trigger--offscreen');
        }
    })
});

function onElementReady(el, callback = () => { }) {
    let iterations = 0;

    const interval = setInterval(() => {
        if ($(el).length) {
            clearInterval(interval);

            callback();
            console.log(`'${el}' found`)
        }
        else if (iterations > 40) {
            // if waiting more than 4sec
            clearInterval(interval);
            console.error(`Could not find '${el}'`)
        }
        else {
            console.log(`Waiting for '${el}'`);
        }
    }, 100)
}
